export const ProfilSettingsTestIds = {
  buttonCopyUserId: 'button_copyUserId',
  presenceStatus: 'presence_status',
  buttonUploadProfile: 'button_uploadProfile',
  buttonDeleteProfile: 'button_deleteProfile',
  inputUploadfile: 'input_uploadfile'
} as const;
